module.exports = __webpack_public_path__ + "img/Stripelg.9e56e9fa.png";